<template>
  <div>
    <v-breadcrumbs :items="crumbs"></v-breadcrumbs>
    <base-loader :isLoading="isLoading"></base-loader>
    <v-row>
      <v-col md="12">
        <v-card>
          <v-card-text>
            <h4 class="text-md-h4 primary--text mb-5">
              {{ `${isEdit ? "Edit" : "New"} Location` }}
              <v-chip label small dark :color="me.role == 'admin' ? 'primary' : 'secondary'">Uploading as {{ me.role }}</v-chip>
            </h4>
            <v-form ref="locationForm" @submit.prevent="save()">
              <v-row>
                <v-col md="12" sm="12">
                  <h5 class="text-md-h5 secondary--text">
                    Basic Information
                  </h5>
                </v-col>
                <v-col md="3">
                  <v-text-field v-model="locationModel.name" label="Location Name" required outlined :rules="[(v) => !!v || 'Location Name is required']"></v-text-field>
                </v-col>
                <v-col md="3">
                  <v-text-field v-model="locationModel.description" label="Location Description" outlined></v-text-field>
                </v-col>
                <v-col md="3">
                  <base-category-picker :chosen-category.sync="locationModel.category" :initial="locationModel.category" label="Category" required outlined :rules="[(v) => !!v || 'Category is required']" />
                </v-col>
                <v-col md="3">
                  <v-text-field v-model="locationModel.telephoneNumber" label="Telephone Number" required outlined></v-text-field>
                </v-col>
                <v-col md="3">
                  <v-text-field v-model="locationModel.emailAddress" label="Email Address" required outlined></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col md="12" sm="12">
                  <h5 class="text-md-h5 secondary--text">
                    Address Information
                  </h5>
                </v-col>
                <v-col md="3">
                  <span v-if="locationModel.fullAddress" class="my-1"> Current location set as {{ locationModel.fullAddress }}. Click input to change it.</span>
                  <base-map-location-picker class="my-1" :zoom="15" :latitude="-26.0985122" :longitude="27.9336247" @locationUpdated="locationUpdated"> </base-map-location-picker>
                  <!-- <base-map-location-picker :zoom="15" :latitude="-26.0985122" :longitude="27.9336247" @locationUpdated="locationUpdated" @clearLocation="clearLocation"> </base-map-location-picker> -->
                </v-col>
              </v-row>
              <v-btn type="submit" color="success">Save</v-btn>
            </v-form>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { Location } from "@/models/Location";
import { gql } from "apollo-boost";
export default {
  data() {
    return {
      isEdit: false,
      isLoading: false,
      locationModel: new Location(),
      chosenPhysicalLocation: null,
      chosenPhysicalAddress: "",
      me: "",
      search: null,
    };
  },
  created() {
    this.isEdit = this.$route.params.id != 0;
    this.isLoading = this.isEdit ? true : false;
  },
  computed: {
    crumbs() {
      return [
        {
          text: "Locations",
          disabled: false,
          href: "/admin/locations",
        },
        {
          text: "Location Detail",
          disabled: false,
          href: `/admin/location/${this.$route.params.id}`,
        },
        {
          text: `${this.isEdit ? "Edit" : "New"} Location`,
          disabled: true,
        },
      ];
    },
  },
  watch: {},
  apollo: {
    me: gql`
      query {
        me {
          id
          role
        }
      }
    `,
    location: {
      query: gql`
        query Location($id: ID!) {
          location(id: $id) {
            id
            name
            description
            category
            telephoneNumber
            emailAddress
            location
            fullAddress
            createdBy
            createdAt
            updatedAt
          }
        }
      `,
      fetchPolicy: "network-only",
      skip() {
        return !this.isEdit;
      },
      variables() {
        const self = this;
        return {
          id: self.$route.params.id,
        };
      },
      result(response, key) {
        console.log(response);
        this.isLoading = false;
        this.locationModel.id = this.location.id;
        this.locationModel.name = this.location.name;
        this.locationModel.description = this.location.description;
        this.locationModel.category = this.location.category;
        this.locationModel.telephoneNumber = this.location.telephoneNumber;
        this.locationModel.emailAddress = this.location.emailAddress;
        this.locationModel.location = this.location.location;
        this.locationModel.fullAddress = this.location.fullAddress;
        this.locationModel.createdBy = this.location.createdBy;
      },
    },
  },
  methods: {
    locationUpdated(location) {
      console.log("Running loc update");
      this.chosenPhysicalLocation = {
        type: "Point",
        coordinates: [location.lng, location.lat],
      };
      this.locationModel.location = this.chosenPhysicalLocation;
      this.chosenPhysicalAddress = location.formatted_address;
      this.locationModel.fullAddress = this.chosenPhysicalAddress;
    },
    clearLocation() {
      console.log("Running clear");
      this.chosenPhysicalLocation = null;
      this.chosenPhysicalAddress = "";
    },
    async save() {
      this.isLoading = true;
      const self = this;
      if (!self.$refs.locationForm.validate()) {
        self.$swal("Error", "Validation failed", "error");
        self.isLoading = false;
        return;
      }
      if (self.isEdit) {
        // update
        await this.updateLocation()
          .then(() => {
            this.$swal("Success!", "Location was updated", "success");
          })
          .catch((e) => {
            console.log(e);
            this.$swal("Error!", "something went wrong when trying to update the location, check data and try again later!", "error");
          });
      } else {
        // create
        await this.createLocation()
          .then(() => {
            this.$swal("Success!", "Location was created", "success");
            window.location.href = `/admin/locations`;
          })
          .catch((e) => {
            console.log(e);
            this.$swal("Error!", `Something went wrong when creating the location, check data and try again later!`, "error");
          });
      }
      this.isLoading = false;
    },
    async updateLocation() {
      const self = this;

      try {
        if (!this.locationModel.location || !this.locationModel.fullAddress) {
          throw "Address details for this location need to be specified!";
        }
        const response = await self.$apollo.mutate({
          mutation: gql`
            mutation update($location: LocationUpdateInput!) {
              updateLocation(location: $location) {
                id
                updated
              }
            }
          `,
          variables: {
            location: {
              id: self.locationModel.id,
              name: self.locationModel.name,
              description: self.locationModel.description,
              category: self.locationModel.category,
              telephoneNumber: self.locationModel.telephoneNumber,
              emailAddress: self.locationModel.emailAddress,
              location: this.locationModel.location,
              fullAddress: this.locationModel.fullAddress,
            },
          },
        });
        if (!response) {
          throw "Something went wrong when creating the Inventory Item!";
        }
        if (response.errors && response.errors.length > 0) {
          throw response.errors[0];
        }
      } catch (e) {
        throw e.message;
      }
    },
    async createLocation() {
      const self = this;
      try {
        if (!this.locationModel.location || !this.locationModel.fullAddress) {
          throw "Address details for this location need to be specified!";
        }
        const response = await self.$apollo.mutate({
          mutation: gql`
            mutation createLocation($location: LocationCreateInput!) {
              createLocation(location: $location) {
                id
              }
            }
          `,
          variables: {
            location: {
              name: self.locationModel.name,
              description: self.locationModel.description,
              category: self.locationModel.category,
              telephoneNumber: self.locationModel.telephoneNumber,
              emailAddress: self.locationModel.emailAddress,
              location: this.locationModel.location,
              fullAddress: this.locationModel.fullAddress,
              createdBy: self.me.id,
            },
          },
        });

        if (!response) {
          throw "Something went wrong when creating the Inventory Item!";
        }
        if (response.errors && response.errors.length > 0) {
          throw response.errors[0];
        }
        if (response && response.data.createLocation) {
          self.locationModel.id = response?.data?.createLocation?.id;
        }
      } catch (e) {
        throw e.message;
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
